const initialize = () => {
    const menuBtn = document.querySelector('.career-hero__nav-mobile-menu')
    const menuIcon = document.querySelector('.career-hero__nav-mobile-menu-icon')
    const navPane = document.querySelector('.career-hero__nav--mobile')
    
    if (!menuBtn)
        return

    document.addEventListener('click', (e) => {
        let isMenu = e.target.closest('.career-hero__nav-mobile-menu')
        let isOpen = menuIcon.classList.contains('fa-chevron-down')
        let isClosed = menuIcon.classList.contains('fa-chevron-up')
        if (isMenu) {
            if (isOpen) {
                openMenu()
            }
            if (isClosed) {
                closeMenu()
            }
        } else {
            if (isClosed) {
                closeMenu()
            }
        }

    })

    function openMenu() {
        menuIcon.classList.add('fa-chevron-up')
        menuIcon.classList.remove('fa-chevron-down')
        navPane.classList.toggle('career-hero__nav--mobile-open')

    }

    function closeMenu() {
        menuIcon.classList.add('fa-chevron-down')
        menuIcon.classList.remove('fa-chevron-up')
        navPane.classList.toggle('career-hero__nav--mobile-open')
    }
}

window.addEventListener('DOMContentLoaded', () => initialize())